import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BookingForm from "../../Forms/BookingForm";
import StandardModal from "../../../../Components/Modals/StandardModal";
import { MODAL_EDIT_BOOKING } from "../../Pages/BookingsLog";
import { hideModal } from "../../../../Redux/GlobalReducer";
import { resetBookingFlow } from "../../Redux/BookingFormSlice";
import BookingFormProvider, { BookingFormContext } from "../../Forms/BookingFormProvider";

const EditBookingModal = (props) => {

    const editBookingId = useSelector(state => state.global.openModals[MODAL_EDIT_BOOKING]);

    // If we're not editing a booking at the moment, we don't want the booking form
    // provider to take over!
    if (!editBookingId) {
        return null;
    }

    return (
        <BookingFormProvider
            editBookingId={editBookingId}
        >
            <EditBookingInner/>
        </BookingFormProvider>
    )
}

const EditBookingInner = (props) => {
    const dispatch = useDispatch();

    const {
        editBookingId,
        booking,
    } = useContext( BookingFormContext );

    const handleClose = () => {
        dispatch( hideModal( MODAL_EDIT_BOOKING ) );
        dispatch( resetBookingFlow() );
    }

    return (
        <StandardModal
            open={!!editBookingId}
            onClose={handleClose}
            title="Edit Booking"
            isScrollable
        >
            {/* Don't display the form until booking is loaded */}
            { (booking && booking.id) &&
                <div style={{ minWidth: 670 }}>
                    <BookingForm
                        editBookingId={editBookingId}
                        onCancel={handleClose}
                    />
                </div>
            }
        </StandardModal>
    );
}

export default EditBookingModal;
